<template>
  <div class="ak-card__header" :class="classes">
    <template v-if="$slots.default">
      <slot />
    </template>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-card-header :type="'comfy">
   *  <p>Lorem ipsum dolor.</p>
   * </ak-card-header>
   */
  name: 'AkCardHeader',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Boolean}
     * @description determines if the relative class should be applied to the card header
     */
    relative: {
      type: Boolean,
      default: false,
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props) {
    const classes = computed(() => {
      const res = []

      if (props.relative) {
        res.push('relative')
      }

      return res
    })

    return {
      classes,
    }
  },
})
</script>
<style lang="scss">
@import '../../scss/_settings.scss';
.ak-card__header {
  width: 100%;
  padding: threequarts($spacing) $spacing;
  border-radius: $base-border-radius $base-border-radius 0 0;
  border-bottom: 1px solid $color-grey-lighter;
  flex-shrink: 0;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }
}
</style>
